export default {
  competence: { competencias_selecionadas: [], competencias_disponiveis: [] },
  tools: {},
  certificates: {},
  usuario: {
    convite_slack_det: '',
    convite_slack_ns: '',
    email: '',
    grupo: '',
    id: '',
    id_cliente: '',
    id_doutor: '',
    id_funcionario: '',
    id_moodle: '',
    id_operacao: '',
    id_usuario_ig: '',
    iniciais: '',
    link_foto_doutor: '',
    nome: '',
    nome_cliente: '',
    nome_foto_doutor: '',
    ns_academy: '',
    operacao_usuario_cliente: '',
    perfil: '',
    renovacao_automatica: '',
    ultimo_login: '',
    url: '',
    usuario_discourse: '',
    valido_ate: '',
  },
  docs: {
    pj: {
      cnpj: '',
      razao_social: '',
      endereco: {}
    },
    pf: {
      nome: '',
      cpf: null,
      rg: '',
      dt_nascimento: '',
    }
  },
  bank: {
    id_banco: '',
    agencia_banco: '',
    dv_agencia_banco: '' ,
    conta_banco: '',
    dv_conta: '',
    tipo_conta: '',
    titular_conta: '',
    operacao_conta: '',
  },
  perfil: {
    nome: '',
    email: '',
    celular: '',
    sexo: null,
    pcd: "N",
  },
  extract: []
};
